import EducationBanner from './EducationBanner'
import BespokeEducation from './BespokeEducation'
import { lazy, Suspense } from 'react'

const EducationService = lazy(() => import("./EducationService"));
const ElearningEducation = lazy(() => import("./ElearningEducation"));
const EasyStepsEd = lazy(() => import("./EasyStepsEd"));
const GreatEducation = lazy(() => import("./GreatEducation"));
const EduCounter = lazy(() => import("./EduCounter"));
const EducationIndustry = lazy(() => import("./EducationIndustry"));
const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const ShuttleItNeed = lazy(() => import("../shuttle_software/ShuttleItNeed"));
const TaxiFaq = lazy(() => import("../taxiDispatchSoftware/TaxiFaq"));

const faqData = [
  {
    id: "0",
    question: "01. What types of education apps do you develop?",
    answer: "We specialize in creating diverse education apps, including Learning Management Systems (LMS), Classroom Management Systems, Student Information Systems (SIS), AR/VR-based immersive learning platforms, gamified educational apps, and AI-powered grading systems.",
  },
  {
    id: "1",
    question: "02. How do you ensure the quality of the education apps?",
    answer: "Our process includes multiple stages of development: discovery, prototyping, design, coding, and rigorous testing to ensure the final product is robust, user-friendly, and error-free.",
  },
  {
    id: "2",
    question: "03. Can you develop apps for both iOS and Android platforms?",
    answer: "Yes, we offer custom solutions for both iOS and Android platforms, ensuring seamless performance and compatibility across devices, including tablets.",
  },
  {
    id: "3",
    question: "04. Do you provide gamification features for learning apps?",
    answer: "Absolutely! We integrate gamification features to make learning interactive, fun, and engaging, which helps improve user retention and motivation.",
  },
  {
    id: "4",
    question: "05. How do you handle data security for education apps?",
    answer: "We prioritize data security by implementing advanced encryption protocols, secure backend systems, and regular vulnerability testing to protect sensitive student and institutional data.",
  },
  {
    id: "5",
    question: "06. Can your apps support immersive learning technologies like AR/VR?",
    answer: "Yes, we specialize in developing apps that offer immersive learning experiences using AR/VR technologies to make education more interactive and impactful.",
  },
  {
    id: "6",
    question:
      "07. How do your solutions support sustainability in education?",
    answer: "We focus on eco-friendly development practices, such as reducing paper-based processes through digitization and building long-lasting, energy-efficient platforms.",
  },
  {
    id: "7",
    question: "08. Do you provide maintenance and post-launch support?",
    answer: "Yes, our services include post-launch support and maintenance to ensure your app runs smoothly and remains up-to-date with technological advancements.",
  },
];

export default function Education() {
  return (
    <>
      <EducationBanner />
      <BespokeEducation />

      <Suspense fallback={null}>
        <EducationService />
        <ElearningEducation />
        <EasyStepsEd />
        <GreatEducation />
        <EduCounter />
        <EducationIndustry />
        <ShuttleAppreciation />
        <ShuttleItNeed />
        <TaxiFaq faqData={faqData} />
      </Suspense>
    </>
  )
}
